/*
 * Minimalne formatowanie tekstu w krótkich akapitach wprowadzających
 * ("Wstęp") na stronach publicznych — świadomie dużo skromniejsze niż
 * richtext.js (edytor odpowiedzi prawnika) czy cms/markdown.js (dokumenty
 * prawne): tylko pogrubienie i akcent kolorem marki, bez list/nagłówków,
 * bo to pojedyncze zdania, nie dokumenty.
 *
 * Składnia: **pogrubienie**, ==akcent kolorem marki==.
 *
 * Świadomie bez dangerouslySetInnerHTML — wraca jako elementy Reacta, więc
 * treść wpisana w panelu admina nie może wstrzyknąć HTML-a.
 */

import React from "react";

export function renderInline(text) {
  if (!text) return text;
  const re = /(\*\*[^*]+\*\*|==[^=]+==)/g;
  const out = [];
  let last = 0;
  let m;
  let i = 0;

  while ((m = re.exec(text)) !== null) {
    if (m.index > last) out.push(text.slice(last, m.index));
    const tok = m[0];
    const key = `f${i++}`;
    if (tok.startsWith("**")) out.push(<strong key={key}>{tok.slice(2, -2)}</strong>);
    else out.push(<mark key={key}>{tok.slice(2, -2)}</mark>);
    last = m.index + tok.length;
  }
  if (last < text.length) out.push(text.slice(last));
  return out;
}
